import { useState, useEffect } from 'react';
import { Box, Button, FormControl, TextField, Stack, Typography } from '@mui/material';
import { useCreateItemMutation, useUpdatePropertyMutation } from '../store/docApi';

function TripForm({ trip, onClose }) {
  const [formData, setFormData] = useState({
    label: 'trip',
    id: '',
    name: '',
    description: '',
    startDate: '',
    endDate: '',
    imageUrl: ''
  });

  const [createTrip] = useCreateItemMutation();
  const [updateProperty] = useUpdatePropertyMutation();

  useEffect(() => {
    if (trip) {
      setFormData({
        label: 'trip',
        id: trip.id || '',
        name: trip.name || '',
        description: trip.description || '',
        startDate: trip.startDate || '',
        endDate: trip.endDate || '',
        imageUrl: trip.imageUrl || ''
      });
    }
  }, [trip]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (trip) {
        // Update each property individually
        const updates = Object.entries(formData).map(([name, value]) =>
          updateProperty({
            label: 'trip',
            id: trip.id,
            name,
            value
          }).unwrap()
        );
        await Promise.all(updates);
      } else {
        await createTrip({ ...formData }).unwrap();
      }
      onClose();
    } catch (error) {
      console.error('Failed to save trip:', error);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Stack spacing={3}>
        <Typography variant="h5">{trip ? 'Edit Trip' : 'Create New Trip'}</Typography>

        <FormControl fullWidth>
          <TextField label="Trip ID" id="trip-id" name="id" value={formData.id} onChange={handleChange} required variant="outlined" />
        </FormControl>

        <FormControl fullWidth>
          <TextField
            label="Trip Name"
            id="trip-name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            variant="outlined"
          />
        </FormControl>

        <FormControl fullWidth>
          <TextField
            label="Description"
            id="trip-description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            multiline
            rows={3}
            variant="outlined"
          />
        </FormControl>

        <FormControl fullWidth>
          <TextField
            label="Start Date"
            id="start-date"
            type="date"
            name="startDate"
            value={formData.startDate}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
          />
        </FormControl>

        <FormControl fullWidth>
          <TextField
            label="End Date"
            id="end-date"
            type="date"
            name="endDate"
            value={formData.endDate}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
          />
        </FormControl>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" variant="contained" color="primary">
            {trip ? 'Update Trip' : 'Create Trip'}
          </Button>
        </Box>
      </Stack>
    </Box>
  );
}

export default TripForm;
